import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";

export class NewbornUnitDashboard extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      module: "",
      profession: "",
      name: "",
      nationality: "",
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
    this.modal = true;
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    var moduleSelected = this.state["module"];
    console.log();
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };

    axios
      .post(
        this.api_url+"billing/status/" + moduleSelected + "/open",
        this.state,
        { headers: headers }
      )
      .then((res) => {
        //   const verified = res.data;
        console.log(res.data);
        if (res.data["status"]) {
          $(".sendModuleSuccess").show();
          setTimeout(function (props) {
            $(".modal").hide();
          }, 3000);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
    axios
      .post(this.api_url+"billing/status/triage/closed", this.state, {
        headers: headers,
      })
      .then((res) => {
        //   const verified = res.data;
        console.log(res.data);
        if (res.data["status"]) {
          // alert('closed_successfully')
          $(".sendModuleSuccess").show();
          setTimeout(function (props) {
            $(".modal").hide();
          }, 3000);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  componentDidMount() {
    console.log(localStorage.getItem("currentVisitId"));
    console.log(localStorage.getItem("currentVisitName"));
    console.log(localStorage.getItem("currentVisitNationality"));
    console.log(localStorage.getItem("currentVisitProfession"));
    //     const article = { title: 'React POST Request Example' };
    // axios.post('https://reqres.in/api/articles', article)
    // .then(response => this.setState({ articleId: response.data.id }));

    $(".sendToModule").on("click", function () {
      $(".module_list").show();
    });
  }

  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right" };
    const floatLeft = { float: "left" };
    const displayHidden = { display: "none" };
    let forgotPasswordUrl = "/forgot/password";
    const { module } = this.state;
    

    const { profession, name, nationality } = this.state;
    return (
      <div>
        <Headers></Headers>
        <section className="service-area more-top-padding" id="services">
          <div className="container">
            <div className="row">
              {/* <div className="card" style="width: 18rem;"> */}
              {/* <ul className="list-group list-group-flush">
    <li className="list-group-item">Cras justo odio</li>
    <li className="list-group-item">Dapibus ac facilisis in</li>
    <li className="list-group-item">Vestibulum at eros</li>
  </ul> */}
              {/* </div> */}
            </div>
            <br />
            <br />

            <div
              className="row wow center bounceInUp"
              data-wow-duration="1.2s"
              data-wow-delay="1.2s"
            >
              <div className="col-md-6 col-lg-4 col-sm-12 mb-4  col-xs-12 center">
                <a
                  className="navbar-brand"
                  href="/newbornunit/newborn/demographic/data"
                >
                  <Card
                    className="innerdashboardcards center"
                    variant="outlined"
                  >
                    <CardActionArea>
                      <div className="full-width center pt-4">
                        <CardMedia
                          className="fa fa-plus-square icon-medium color-blue"
                          component="icon"
                          alt="Triage"
                        />
                      </div>
                      <CardContent>
                        <Typography
                          align="center"
                          gutterBottom
                          variant="h6"
                          component="div"
                          className="color-blue"
                        >
                          Newborn Demographic Data
                        </Typography>
                        <Typography
                          gutterBottom
                          component="div"
                          variant="p"
                          align="center"
                          paragraph="true"
                          className="innerdashcardsp"
                        ></Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </a>
              </div>
              <div className="col-md-6 col-lg-4 col-sm-12 mb-4  col-xs-12 center">
                <a
                  className="navbar-brand"
                  href="/newbornunit/treatment/counselling"
                >
                  <Card
                    className="innerdashboardcards center"
                    variant="outlined"
                  >
                    <CardActionArea>
                      <div className="full-width center pt-4">
                        <CardMedia
                          className="fa fa-plus-square icon-medium color-blue"
                          component="icon"
                          alt="Triage"
                        />
                      </div>
                      <CardContent>
                        <Typography
                          align="center"
                          gutterBottom
                          variant="h6"
                          component="div"
                          className="color-blue"
                        >
                          Treatment And Counselling
                        </Typography>
                        <Typography
                          gutterBottom
                          component="div"
                          variant="p"
                          align="center"
                          paragraph="true"
                          className="innerdashcardsp"
                        ></Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </a>
              </div>
              <div className="col-md-6 col-lg-4 col-sm-12 mb-4  col-xs-12 center">
                <a
                  className="navbar-brand"
                  href="/newbornunit/physical/examination"
                >
                  <Card
                    className="innerdashboardcards center"
                    variant="outlined"
                  >
                    <CardActionArea>
                      <div className="full-width center pt-4">
                        <CardMedia
                          className="fa fa-plus-square icon-medium color-blue"
                          component="icon"
                          alt="Triage"
                        />
                      </div>
                      <CardContent>
                        <Typography
                          align="center"
                          gutterBottom
                          variant="h6"
                          component="div"
                          className="color-blue"
                        >
                          Newborn Physical Examination
                        </Typography>
                        <Typography
                          gutterBottom
                          component="div"
                          variant="p"
                          align="center"
                          paragraph="true"
                          className="innerdashcardsp"
                        ></Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </a>
              </div>
              <div className="col-md-6 col-lg-4 col-sm-12 mb-4  col-xs-12 center">
                <a className="navbar-brand" href="/newbornunit/procedures">
                  <Card
                    className="innerdashboardcards center"
                    variant="outlined"
                  >
                    <CardActionArea>
                      <div className="full-width center pt-4">
                        <CardMedia
                          className="fa fa-plus-square icon-medium color-blue"
                          component="icon"
                          alt="Triage"
                        />
                      </div>
                      <CardContent>
                        <Typography
                          align="center"
                          gutterBottom
                          variant="h6"
                          component="div"
                          className="color-blue"
                        >
                          Newborn Procedures
                        </Typography>
                        <Typography
                          gutterBottom
                          component="div"
                          variant="p"
                          align="center"
                          paragraph="true"
                          className="innerdashcardsp"
                        ></Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </a>
              </div>
              <div className="col-md-6 col-lg-4 col-sm-12 mb-4  col-xs-12 center">
                <a className="navbar-brand" href="/newbornunit/referral">
                  <Card
                    className="innerdashboardcards center"
                    variant="outlined"
                  >
                    <CardActionArea>
                      <div className="full-width center pt-4">
                        <CardMedia
                          className="fa fa-plus-square icon-medium color-blue"
                          component="icon"
                          alt="Triage"
                        />
                      </div>
                      <CardContent>
                        <Typography
                          align="center"
                          gutterBottom
                          variant="h6"
                          component="div"
                          className="color-blue"
                        >
                          Referral Form
                        </Typography>
                        <Typography
                          gutterBottom
                          component="div"
                          variant="p"
                          align="center"
                          paragraph="true"
                          className="innerdashcardsp"
                        ></Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </a>
              </div>

              <div className="col-md-4 col-sm-6 mb-4  col-xs-12  center"></div>
            </div>
            <a className="btn btn-primary sendToModule">Send to Module</a>
          </div>
        </section>

        <div className="modal module_list" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title PatientName"></h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="full-width">
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-row pt-4">
                      <div className="col-md-4 p-2">
                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Choose Module
                          </h6>
                          <select
                            onChange={this.handleChange}
                            value={module}
                            name="module"
                            className="form-control selectModule"
                          >
                            <optgroup label="Attended Antenatal Care">
                              <option selected disabled></option>
                              <option value="gynecology">
                                Gynecology Ward
                              </option>
                              <option value="gynecology2">
                                Gynecology Ward II
                              </option>
                              <option value="labour">Labour </option>
                            </optgroup>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <br />
                      <br />
                      <br />
                      {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                      <div className="col col-6">
                        <button
                          className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                          type="submit"
                          style={floatLeft}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="modal-footer">
                <p
                  className="alert alert-success sendModuleSuccess"
                  style={displayHidden}
                >
                  Patient Sent Successfully
                </p>
                {/* <button type="button" className="btn btn-primary sendToModule" id="">Send To Module</button> */}
                {/* <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NewbornUnitDashboard;
